import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import RadioButton from '../../common/RadioButton'
import { ConnectorViewMappingContext } from './context/context'
import DuplicateSvgGroup from './DuplicateSvgGroup'
import { useParams } from 'react-router-dom'

const ReferenceItem = ({ reference, selected }) => {
  const { connector_view } = useParams()
  const [state, dispatch] = useContext(ConnectorViewMappingContext)
  const onChange = (evt) => {
    dispatch({ type: 'selected_reference', data: reference })
  }
  return (
    <div
      className="flex flex-col flex-grow items-center bg-white w-full px-2 py-3 border-b border-tracer-dark-blue cursor-pointer group hover:bg-blue-100"
      id={`ref-${reference}`}
    >
      <div className="flex flex-row flex-grow items-center w-full cursor-pointer group">
        <div>
          <RadioButton
            name={reference}
            value={reference}
            onChange={onChange}
            checked={selected}
          />
        </div>
        <div className="w-full pl-2" onClick={onChange}>
          <div className="flex w-full font-bold group p-2 break-all text-sm">
            {reference}
          </div>
        </div>
      </div>
      {/* <DuplicateSvgGroup
        connectorViewId={connector_view}
        reference={reference}
      /> */}
    </div>
  )
}

ReferenceItem.propTypes = {
  reference: PropTypes.string.isRequired,
  selected: PropTypes.bool,
}

export default ReferenceItem
